import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {useFormik} from 'formik';
import {LANGUAGES} from "../../../mock/languages";
import {useNotification} from "../../../context/NotificationContext";
import {createNotification} from "../../../services/notificationSvc";
import {createNotificationSchema} from "../../../schema/notificationSchema";
import {lang} from "../../../types/lang";
import {UploadImage} from "../../../components/common/uploadImage/UploadImage";

export const NotificationCreatePage = () => {
  const navigate = useNavigate();
  const {formatMessage} = useIntl();
  const {showNotification} = useNotification();
  const [activeTab, setActiveTab] = useState<lang>("uz");

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: {
        uz: '',
        ru: '',
        en: '',
      },
      message: {
        uz: '',
        ru: '',
        en: '',
      },
      banner: null,
      user: "",
      type: "ALL",
    },
    validationSchema: createNotificationSchema,
    onSubmit: async (values, {
      resetForm
    }) => {
      const formData = new FormData();
      formData.append(`title_uz`, values.title.uz);
      formData.append(`title_ru`, values.title.ru);
      formData.append(`title_en`, values.title.en);
      formData.append(`message_uz`, values.message.uz);
      formData.append(`message_ru`, values.message.ru);
      formData.append(`message_en`, values.message.en);
      formData.append("type", values.type);

      if (values.banner) {
        formData.append("banner", values.banner);
      }

      try {
        const res = await createNotification(formData);
        if (res?.success) {
          showNotification("Muvaffaqiyatli", "Xabar qo'shildi", "success")
          resetForm();
          setTimeout(() => {
            navigate(-1)
          }, 1000)
        }
      } catch (e) {
        showNotification("Xatolik!", "", "error")
      }
    },
  });

  const handleTabChange = (lang) => {
    setActiveTab(lang);
  };

  return (
      <div>
        <div className={"card"}>
          <div className="card-header">
            <h1 className="card-title">Xabar qo'shish</h1>
            <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
              {LANGUAGES.map((lang) => (
                  <li className="nav-item" key={lang.key}>
                    <button
                        className={`nav-link ${activeTab === lang.key ? 'active' : ''}`}
                        onClick={() => handleTabChange(lang.key)}
                    >
                      {lang.name}
                    </button>
                  </li>
              ))}
            </ul>
          </div>
          <div className="card-body">
            <div id="kt_account_profile_details" className="collapse show">
              <form
                  className="form"
                  onSubmit={formik.handleSubmit}
                  encType="multipart/form-data"
              >
                <div className="card-body p-9">
                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label fw-bold fs-6">
                      Banner
                    </label>
                    <div className="col-lg-8 fv-row">
                      <UploadImage
                          onImageUpload={(file) => formik.setFieldValue("banner", file)}
                          onImageRemove={() => formik.setFieldValue("banner", null)}
                          imageSizes={"banner"}
                      />
                      {formik.touched.banner && formik.errors.banner && (
                          <div className="text-danger">{formik.errors.banner}</div>
                      )}
                    </div>
                  </div>


                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                      Sarlavha
                    </label>
                    <div className="col-lg-8 fv-row">
                    <textarea
                        className="form-control form-control-lg form-control-solid"
                        placeholder="Xabar sarlavhasi"
                        name={`title.${activeTab}`}
                        value={formik.values.title[activeTab]}
                        onChange={formik.handleChange}
                    />
                      {formik.touched.title?.[activeTab] && formik.errors.title?.[activeTab] && (
                          <div className="text-danger">{formik.errors.title[activeTab]}</div>
                      )}
                    </div>
                  </div>


                  <div className="row mb-6">
                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                      Matn
                    </label>
                    <div className="col-lg-8 fv-row">
                    <textarea
                        className="form-control form-control-lg form-control-solid"
                        placeholder="Xabar matnini kiriting"
                        name={`message.${activeTab}`}
                        value={formik.values.message[activeTab]}
                        onChange={formik.handleChange}
                        rows={5}
                    />
                      {formik.touched.message?.[activeTab] && formik.errors.message?.[activeTab] && (
                          <div className="text-danger">{formik.errors.message[activeTab]}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="justify-content-end d-flex gap-2">
                    <button
                        className="btn btn-secondary"
                        onClick={() => navigate(-1)}
                        type="button"
                    >
                      {formatMessage({id: "Bekor qilish"})}
                    </button>
                    <button
                        disabled={formik.isSubmitting}
                        className="btn btn-primary"
                        type="submit"
                    >
                      {
                        formik.isSubmitting ? "Saqlanmoqda..." : "Saqlash"
                      }
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  );
};